<ng-template #actionList let-items="items" let-disabled="disabled">
    @for (item of items; track $index) {
        <li 
            [class.disabled]="disabled"
            [attr.tabindex]="disabled ? -1 : 0"
            (click)="!disabled && executeAction(item)"
            (keydown.enter)="!disabled && executeAction(item)">
            <p>{{item.name | abpLocalization}}</p>
        </li>
    }
</ng-template>
<div class="zn-layout dropdown">
    <zn-button
        [label]="localizationResource + '::ZnOtherActions'  | abpLocalization"
        type="secondary"
        size="normal"
        iconRight="bi bi-chevron-down"
        [attr.data-bs-toggle]="'dropdown'"
        aria-expanded="false">
    </zn-button>
 
    <div class="dropdown-menu zn-dropdown" aria-labelledby="dropdownLayouts">
        <ul class="zn-layout-list">
            @if (actionsOverTable().length > 0) {
                <li class="zn-layout-list-header">
                    <p>{{ localizationResource + '::ZnOtherActionsOverTable' | abpLocalization }}</p>
                </li>
                <ng-container *ngTemplateOutlet="actionList; context: { items: actionsOverTable() }"/>
                <hr class="zn-separator" />
            }
            @if (actionsMultipleRecord().length > 0) {
                <li class="zn-layout-list-header" [class.disabled]="!enableMultipleRecordActions()">
                    <p>{{ localizationResource + '::ZnOtherActionsOverRecords' | abpLocalization }}</p>
                </li>
                <ng-container *ngTemplateOutlet="actionList; context: { items: actionsMultipleRecord(), disabled: !enableMultipleRecordActions() }"/>
                <hr class="zn-separator" />
            }
            @if (actionsSingleRecord().length > 0) {
                <li class="zn-layout-list-header" [class.disabled]="!enableSingleRecordActions()">
                    <p>{{ localizationResource + '::ZnOtherActionsOverSingleRecord' | abpLocalization }}</p>
                </li>
                <ng-container *ngTemplateOutlet="actionList; context: { items: actionsSingleRecord(), disabled: !enableSingleRecordActions() }"/>
            }
        </ul>
    </div>
</div>